export class MenuComponentModel {
	ComponentUuids?: string;
	ComponentVariantUuids: string;
}
